import React from 'react'
import PropTypes from 'prop-types'
import {Text, Tooltip} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const MCoinCell = ({getValue}) => {
  const {t} = useTranslation('pointsOnPayments')
  const mp = getValue()
  const points = mp?.amount ?? 0

  return (
    <Text
      textDecoration="underline dotted"
      textDecorationColor="mld.neutral.500"
      textUnderlineOffset="3px"
      whiteSpace="nowrap"
    >
      <Tooltip label={t('pointsOnPayments:bill.table.columns.body.mCoinTooltip')} placement="bottom" hasArrow>
        <Text as="span" cursor="default">
          <Text as="span" color="mld.success.700">
            +
          </Text>{' '}
          {points.toLocaleString()}
        </Text>
      </Tooltip>
    </Text>
  )
}

MCoinCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default MCoinCell
